import { Form } from "@redriver/cinnamon";
import React from "react";
import { getContractStatuses } from "./actions";

const ContractStatusesDropdown = ({ ...props }) => (
  <Form.Dropdown lookupAction={getContractStatuses} {...props} />
);

export default ContractStatusesDropdown;
